import {Component, Input, OnInit} from '@angular/core';
import {ActionMode} from '../../../../shared/enums/action-mode.enum';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {EmployeeDesignationService} from '../../../../shared/service/employee-designation.service';
import swal from "sweetalert2";
import {EmployeeDesignationDTO} from '../../../../shared/dto/employee-designation.model';
import {TokenStorageService} from '../../../../shared/service/token-storage.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-employee-designation-popup',
  templateUrl: './employee-designation-popup.component.html',
  styleUrls: ['./employee-designation-popup.component.scss']
})
export class EmployeeDesignationPopupComponent implements OnInit {
  @Input() designationMgtCopy_: EmployeeDesignationDTO[];
  designationMgt: any;
  destinationPopup: FormGroup;
  public selectedState: string;
  ActionMode = ActionMode;
  public code: string;
  public description: string;
  public selectedMode;

  public designationDTO: EmployeeDesignationDTO [] = [];
  public href: string = "";

  constructor(public activeModal: NgbActiveModal,
              private employeeDesignationService: EmployeeDesignationService,
              private tokenStorageService: TokenStorageService,
              private router : Router) { }

  ngOnInit() {
    this.destinationPopup = new FormGroup({
      code: new FormControl(null,Validators.required),
      description: new FormControl(null,Validators.required),
      states: new FormControl(null,Validators.required),
    });
    this.href = this.router.url;
    this.designationMgt = {...this.designationMgtCopy_};
    if (this.selectedMode === ActionMode.VIEW) {
      this.destinationPopup.disable();
    }
  }

  onSubmit(){
    let isValid: boolean = true;
    let errorMessage: string = '';

    // if (!this.employeePopup.valid) {
    //   isValid = false;
    //   errorMessage = 'Please, Fill the form Data...!'
    // }
    if (isValid) {
      swal.fire({
        title: "Are you sure, you want to submit?",
        text: "",
        showCancelButton: true,

        confirmButtonText: "Yes"
      }).then((result) => {
        if(result.value) {
          const employeeDesignationDTO: EmployeeDesignationDTO = new EmployeeDesignationDTO(
            this.code,
            this.description,
            this.selectedState,
            this.tokenStorageService.getUserObjectToken().username,
            this.href
          );
          this.employeeDesignationService.saveEmployeeDesignations(employeeDesignationDTO).subscribe(
            (success: string) => {
              swal.fire("Success", "Details submitted successfully", "success");
            },
            (error) => {
              console.log(error);
              swal.fire("Sorry!", "Something went wrong...!", "error");
            },
            () => {
              this.activeModal.close("Saved");
            }
          );
        }
        }, reason => {
        }
      );
    } else{
      swal.fire('Error',errorMessage,'error');
    }
  }
}
